"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeInstance = exports.makeAuthInstance = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _constants = _interopRequireDefault(require("../constants"));
var _AuthStrategy = require("../services/AuthStrategy");
var _storage = require("../utils/storage");
const getXSRFCookieName = connectorName => {
  switch (connectorName) {
    case _constants.default.PCAS_CONNECTOR:
    default:
      return _constants.default.PCAS_XSRF_COOKIE_NAME;
  }
};
const makeAuthInstance = config => {
  const instance = _axios.default.create({
    headers: {
      'Content-Type': 'application/json'
    }
  });
  instance.interceptors.request.use(conf => {
    var _config$auth;
    if (((_config$auth = config.auth) === null || _config$auth === void 0 ? void 0 : _config$auth.connector) === _constants.default.MID2_CONNECTOR) {
      conf.headers.Authorization = `Bearer ${(0, _storage.getMidAccessToken)()}`;
    }
    return conf;
  });
  instance.interceptors.response.use(response => response.data, error => {
    if (error.response && error.response.status === 401) {
      _AuthStrategy.authStrategy.redirectToLogin();
    }
    throw error;
  });
  return instance;
};
exports.makeAuthInstance = makeAuthInstance;
const makeInstance = config => {
  var _config$auth2, _config$auth3;
  const csrfSettings = {
    xsrfCookieName: getXSRFCookieName((_config$auth2 = config.auth) === null || _config$auth2 === void 0 ? void 0 : _config$auth2.connector),
    xsrfHeaderName: 'X-CSRF-Token'
  };
  const additionalSettings = ((_config$auth3 = config.auth) === null || _config$auth3 === void 0 ? void 0 : _config$auth3.connector) === _constants.default.MID2_CONNECTOR ? {} : csrfSettings;
  const instance = _axios.default.create({
    headers: {
      'Content-Type': 'application/json'
    },
    ...additionalSettings
  });
  instance.interceptors.request.use(conf => {
    var _config$auth4;
    if (((_config$auth4 = config.auth) === null || _config$auth4 === void 0 ? void 0 : _config$auth4.connector) === _constants.default.MID2_CONNECTOR) {
      conf.headers.Authorization = `Bearer ${(0, _storage.getMidAccessToken)()}`;
    }
    return conf;
  });
  instance.interceptors.response.use(response => {
    if (response.headers && response.headers['content-type'] && response.headers['content-type'].includes('text/html')) {
      throw new Error('Incorrect content type');
    }
    return response.data;
  }, error => {
    if (error.response && error.response.status === 401) {
      _AuthStrategy.authStrategy.redirectToLogin();
    }
    throw error;
  });
  return instance;
};
exports.makeInstance = makeInstance;